import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
    FilterWrapper,
    StyledDropdownWithLabel
} from './SearchInitiationMobile.styles';

const DropdownWrapper = styled.div(
    () => css`
        display: flex;
    `
);

const LeftWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        padding-right: ${spacing['8px']};
        width: 50%;
    `
);

const RightWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        padding-left: ${spacing['8px']};
        width: 50%;
    `
);

const priceOptions = [
    '10000',
    '20000',
    '30000',
    '40000',
    '50000',
    '60000',
    '70000',
    '80000',
    '90000',
    '100000',
    '110000',
    '120000',
    '125000',
    '130000',
    '140000',
    '150000',
    '160000',
    '170000',
    '180000',
    '190000',
    '200000',
    '210000',
    '220000',
    '230000',
    '240000',
    '250000',
    '275000',
    '300000',
    '325000',
    '350000',
    '375000',
    '400000',
    '425000',
    '450000',
    '475000',
    '500000',
    '550000',
    '600000',
    '650000',
    '700000',
    '750000',
    '800000',
    '850000',
    '900000',
    '950000',
    '1000000',
    '1100000',
    '1200000',
    '1300000',
    '1400000',
    '1500000',
    '1600000',
    '1700000',
    '1800000',
    '1900000',
    '2000000',
    '2100000',
    '2200000',
    '2300000',
    '2400000',
    '2500000',
    '2750000',
    '3000000',
    '3250000',
    '3500000',
    '3750000',
    '4000000',
    '4250000',
    '4500000',
    '4750000',
    '5000000',
    '5500000',
    '6000000',
    '6500000',
    '7000000',
    '7500000',
    '8000000',
    '8500000',
    '9000000',
    '9500000',
    '10000000',
    '12500000',
    '15000000'
];

type prices = typeof priceOptions[number];

export type PriceMax = prices;

const beds = ['', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

const bedsOptions = [
    { value: '0', text: 'Studio' },
    { value: '1', text: '1' },
    { value: '2', text: '2' },
    { value: '3', text: '3' },
    { value: '4', text: '4' },
    { value: '5', text: '5' },
    { value: '6', text: '6' },
    { value: '7', text: '7' },
    { value: '8', text: '8' },
    { value: '9', text: '9' },
    { value: '10', text: '10+' }
];

export type BedsMin = typeof beds[number];

type SelectBedsPriceForSaleProps = {
    value: {
        bedsMin: BedsMin;
        priceMax: PriceMax;
    };
    onChange: ({
        bedsMin,
        priceMax
    }: {
        bedsMin: BedsMin;
        priceMax: PriceMax;
    }) => void;
};

export const SelectBedsPriceForSale = ({
    value,
    onChange
}: SelectBedsPriceForSaleProps) => {
    const minBedsLabel = 'Bedrooms';
    const maxPriceLabel = 'Max price';

    const bedsMinOptions = bedsOptions;
    const priceMaxOptions = priceOptions;

    return (
        <FilterWrapper>
            <DropdownWrapper>
                <LeftWrapper>
                    <StyledDropdownWithLabel
                        id="mobile_beds_min"
                        onChange={(e) => {
                            onChange({
                                ...value,
                                bedsMin: e.target.value
                            });
                        }}
                        value={value.bedsMin}
                        name="beds_min"
                        aria-label="Min Beds"
                        data-testid="min_beds_mobile"
                        label={minBedsLabel}
                        hasBorderRadius
                    >
                        <option value="">No min</option>
                        {bedsMinOptions.map((bedsMinOption, index) => {
                            return (
                                <option
                                    value={bedsMinOption.value}
                                    key={`mobile_beds_mins_${index}`}
                                >
                                    {bedsMinOption.text}
                                </option>
                            );
                        })}
                    </StyledDropdownWithLabel>
                </LeftWrapper>
                <RightWrapper>
                    <StyledDropdownWithLabel
                        id="price_max_mobile"
                        onChange={(e) => {
                            onChange({
                                ...value,
                                priceMax: e.target.value
                            });
                        }}
                        value={value.priceMax}
                        name="price_max"
                        aria-label="Max Price"
                        data-testid="max_price_mobile"
                        label={maxPriceLabel}
                        hasBorderRadius
                    >
                        <option value="">No max</option>
                        {priceMaxOptions.map((priceMaxOption, index) => {
                            const price = new Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: 'GBP',
                                maximumFractionDigits: 0,
                                minimumFractionDigits: 0
                            }).format(Number(priceMaxOption));

                            return (
                                <option
                                    value={priceMaxOption}
                                    key={`mobile_price_max_${index}`}
                                >
                                    {price}
                                </option>
                            );
                        })}
                    </StyledDropdownWithLabel>
                </RightWrapper>
            </DropdownWrapper>
        </FilterWrapper>
    );
};
